import { ZoomInMap } from '@mui/icons-material';
import {
  Box,
  IconButton,
  Slider,
  Tooltip,
  Popover,
  Typography
} from '@mui/material';
import { Editor } from "@tiptap/react";
import { useEffect, useRef, useState } from "react";

interface NoteZoomProps {
  editor: Editor;
  noteZoom: number;
  setNoteZoom: React.Dispatch<React.SetStateAction<number>>;
  mode: number;
}

export default function NoteZoom({ editor, noteZoom, setNoteZoom, mode }: NoteZoomProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const popoverRef = useRef<HTMLDivElement | null>(null);

  const handleZoomClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleZoomClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'zoom-popover' : undefined;

  // Close popover if focus moves outside of it
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
        handleZoomClose();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <>
      <Tooltip title="Zoom" placement="left">
        <IconButton onClick={handleZoomClick} sx={{ color: '#9c27b0' }}>
          <ZoomInMap />
        </IconButton>
      </Tooltip>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleZoomClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        disableRestoreFocus
        PaperProps={{
          ref: popoverRef,
          sx: {
            p: 2,
            width: 150,
            backgroundColor: mode === 0 ? "#1e1e1e" : "#fff",
            color: mode === 0 ? "white" : "#121212"
          }
        }}
      >
        <Typography variant="caption" gutterBottom>
          Zoom: {Math.round(noteZoom * 100)}%
        </Typography>
        <Slider
          min={0.5}
          max={2}
          step={0.05}
          value={noteZoom}
          onChange={(_, value) => setNoteZoom(value as number)}
          size="small"
        />
      </Popover>
    </>
  );
}
